// extracted by mini-css-extract-plugin
module.exports = {"Legal":"Legal_Legal__2THfN","Icon":"Legal_Icon__1YAtx"};